import React from "react";
// import { ReactComponent as Success } from "@deere/ux.brand-foundations/icons/check_circle.svg";
// import { ReactComponent as Failed } from "@deere/ux.brand-foundations/icons/critical.svg";
// import { ReactComponent as InProgress } from "@deere/ux.brand-foundations/icons/history.svg";
// import { ReactComponent as Help } from "@deere/ux.brand-foundations/icons/help.svg";
import { Box, Typography } from "@mui/material";
export default function RenderStatus(props) {
  const { value } = props;

  let icon;
  switch (value) {
    case "FAILED":
    case "EXPIRED":
      icon = <fuel-icon  style={{color: "red"}} name={"error"} />;
      break;
    case "IN PROGRESS":
    case "EXPIRING SOON":
      icon = <fuel-icon name={"schedule"} />;
      break;
    case "SUCCESS":
    case "VALID":
      icon = <fuel-icon style={{color: "green"}}  name={"check_circle"} />;
      break;
    default:
      icon = <fuel-icon name={"help"} />;
  }
  return (
    <Box alignItems={"center"} display={"flex"} flexDirection={"row"}>
      {icon}
      <Typography pl={".25rem"} size="sm" component="p">
        {value}
      </Typography>
    </Box>
  );
}
